import { render, staticRenderFns } from "./PartExpense.vue?vue&type=template&id=1b72fb9a&lang=pug&"
import script from "./PartExpense.vue?vue&type=script&lang=ts&"
export * from "./PartExpense.vue?vue&type=script&lang=ts&"
import style0 from "./PartExpense.vue?vue&type=style&index=0&id=1b72fb9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports